export default __webpack_public_path__ + "static/media/background.6b42c038.jpg";